export default __webpack_public_path__ + "static/media/IconGooglePlayWhite.7b3d67a0.svg";